module.exports = __webpack_public_path__ + "12dab3583a74c18e.otf";